var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whole_task_div"},[_c('div',{staticStyle:{"font-size":"17px","font-weight":"bold"}},[_vm._t("title")],2),_c('div',{staticStyle:{"font-size":"15px","margin-top":"10px"}},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }